<template>
  <div>
    <h1 id="jump-to-header">{{heading || generated_heading}}</h1>
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-warning"
      active-tab-class="font-weight-bold text-success"
      content-class="mt-3"
      lazy
    >
      <b-tab title="Settings" active>
        <product-item-update :id="id" @gotAttrs="assignAttrs" @gotDescription="assignDescription" @gotCollection="assignCollection"/>
      </b-tab>
      <b-tab title="Images">
        <asset-image-link-index
          :filtering="filtering"
          :ams_template="ams_collection_image_template"
          :description="description"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProductItemUpdate from './ProductItemUpdate.vue'
import AssetImageLinkIndex from './AssetImageLinkIndex.vue'

export default {
  components: {
    ProductItemUpdate,
    AssetImageLinkIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        product_item_ids: this.id
      },
      ams_collection_image_template: {
        type: 'collection-images',
        attributes: {
          'product-item-id': this.id,
          'collection-id': undefined
        }
      },
      attrs: {},
      description: undefined
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
    },
    assignDescription(description) {
      this.description = description
    },
    assignCollection(collection) {
       this.ams_collection_image_template.attributes['collection-id'] = collection.id
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>